module.exports = __webpack_public_path__ + "img/injoy_xpress.4fbf1b24.png";